import { useState } from 'react';
import {
    isDisplayBtnCopyMsgId,
    isDisplayReactionBtn,
    isEditedMsg,
    onClickShowEditMsg,
    onOpenHistoryDialog
} from './handler/MessageHandler';
import { isAIAssistantThread } from './handler/ChatThreadHandler';
import { IconButton, Tooltip } from '@material-ui/core';
import { hideLoadingMouse, showLoadingMouse } from '@/common/utils/CustomCursor';
import Constant from '@/common/constant/Constant';
import { validateBeforeHandleChatInEmailTicket } from './handler/ChatPostHandler';
import { disableAutoScroll } from './handler/FootprintHandler';
import Utils from '@/common/utils/utils';
import MessageMoreMenu from './tooltip/MessageMoreMenu';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const ChatBoxToolTicket = ({
    ticketInfo,
    item,
    setChatPostShowFlagMsgCopyMsgId,
    isDisableLink,
    genMessageCopyShortLink,
    isDisplayBtnEdit,
    setIsOpenModalReloadPage,
    setOpenModalDeleteMsg,
    selectThread,
    isDisplayBtnDelete,
    setReactionPopoverId,
    setReactionPopover,
    reactionId,
    isEnableChat,
    editedMsgList,
    setIsOpenHistoryDialog,
    setIsLoadingHistoryList,
    setHistoryList,
    setMsgEditSelected,
    userChatList,
    setIsShowModalEditMsg,
    msgRefList,
    chatPostAllList,
    setChatPostUpdate,
    itemFile,
    chatPostShowFlagMsgCopyMsgId,
}) => {
    useTranslationSubscription();
    const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

    if (isAIAssistantThread(selectThread)) return null;

    // Id dùng để bật flag "リンクをコピーしました。" (tooltip xanh) trên đúng phần tử
    const copyFlagId = !Utils.isEmptyObject(itemFile) ? itemFile?.id : item?.id;

    const canCopyAttachmentShareLink = Boolean(
        !Utils.isEmptyObject(itemFile) &&
        !Utils.isEmptyString(itemFile?.shortKey) &&
        Utils.isEmptyString(ticketInfo?.deletedAt) &&
        !Utils.isEmptyObject(ticketInfo?.dataShareLink)
    );

    const canCopyMessageLink = isDisplayBtnCopyMsgId(item, ticketInfo, selectThread);
    const canShowHistory =
        !isDisableLink &&
        isEditedMsg(editedMsgList, item) &&
        item?.deliverInfo?.status !== 0 &&
        Utils.isEmptyString(ticketInfo?.deletedAt);
    const canDelete = !isDisableLink && isDisplayBtnDelete(item);

    const showFlagMsgCopy = () => {
        if (!setChatPostShowFlagMsgCopyMsgId) return;
        setChatPostShowFlagMsgCopyMsgId(prev => ({ ...prev, [copyFlagId]: true }));
        setTimeout(() => {
            setChatPostShowFlagMsgCopyMsgId(prev => ({ ...prev, [copyFlagId]: false }));
        }, 3000);
    };

    const onClickCopyLink = shareLink => {
        if (Utils.isEmptyString(shareLink)) return;
        navigator.clipboard.writeText(shareLink);
        showFlagMsgCopy();
    };

    const onClickCopyMessageLink = () => onClickCopyLink(genMessageCopyShortLink(item));

    const onClickCopyFileLink = () =>
        onClickCopyLink(
            Utils.getShareLinkImg({
                attachFile: itemFile,
                dataShareLink: ticketInfo?.dataShareLink
            })
        );

    const onClickOpenHistory = () =>
        onOpenHistoryDialog(
            null,
            item,
            setIsOpenHistoryDialog,
            setIsLoadingHistoryList,
            setHistoryList,
            setMsgEditSelected,
            userChatList
        );

    const isEmailCustomerThreadOwnTicket =
        ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL &&
        item?.ticketId === ticketInfo.id &&
        selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER;

    const onClickDeleteMsg = async () => {
        if (isEmailCustomerThreadOwnTicket) return;
        if (ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL) {
            showLoadingMouse();
            const validateData = await validateBeforeHandleChatInEmailTicket(null, ticketInfo);
            hideLoadingMouse();
            if (!validateData.status) {
                setIsOpenModalReloadPage(true);
                return;
            }
        }
        setOpenModalDeleteMsg({ isOpen: true, msg: item });
    };

    const onClickEditMsg = async () => {
        if (ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL) {
            showLoadingMouse();
            const validateData = await validateBeforeHandleChatInEmailTicket(null, ticketInfo);
            hideLoadingMouse();
            if (!validateData.status) {
                setIsOpenModalReloadPage(true);
                return;
            }
        }
        await onClickShowEditMsg(
            null,
            item,
            setMsgEditSelected,
            setIsShowModalEditMsg,
            msgRefList,
            chatPostAllList,
            setChatPostUpdate
        );
    };

    const hasMoreMenu = canCopyMessageLink || canCopyAttachmentShareLink || canShowHistory || canDelete;

    const moreMenuActions = [
        {
            key: 'copy-message-link',
            label: trI18n('CHATPOST-COPY-MESSAGE-LINK'),
            icon: '/assets/image/html-link-icon.svg',
            visible: canCopyMessageLink,
            onClick: onClickCopyMessageLink
        },
        {
            key: 'copy-file-link',
            label: trI18n('CHATPOST-COPY-FILE-LINK'),
            icon: '/assets/image/icon-copy-file.svg',
            visible: canCopyAttachmentShareLink,
            onClick: onClickCopyFileLink
        },
        {
            key: 'edit-history',
            label: trI18n('COMBTN016'),
            icon: '/assets/image/icon-time.svg',
            visible: canShowHistory,
            onClick: onClickOpenHistory
        },
        {
            key: 'delete',
            label: trI18n('COMBTN013'),
            icon: '/assets/image/delete-icon.svg',
            visible: canDelete,
            disabled: isEmailCustomerThreadOwnTicket,
            onClick: onClickDeleteMsg
        }
    ];

    return (
        <div className={`chatBox-tools${isMoreMenuOpen ? ' chatBox-tools--menu-open' : ''}`}>
            <ul>
                {!isDisableLink && isDisplayReactionBtn(ticketInfo, item, selectThread, isEnableChat) && (
                    <li>
                        <Tooltip title={trI18n('COMBTN015')} placement="top" arrow>
                            <IconButton
                                aria-describedby={reactionId}
                                onClick={event => {
                                    disableAutoScroll(true);
                                    setReactionPopover(event.currentTarget);
                                    setReactionPopoverId(item?.id);
                                }}
                            >
                                <img src="/assets/image/icon-reaction.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {!isDisableLink && isDisplayBtnEdit(item) && (
                    <li>
                        <Tooltip title={trI18n('COMBTN012')} placement="top" arrow>
                            <IconButton onClick={onClickEditMsg}>
                                <img src="/assets/image/edit-icon.svg" alt="" />
                            </IconButton>
                        </Tooltip>
                    </li>
                )}

                {hasMoreMenu && (
                    <li>
                        <MessageMoreMenu actions={moreMenuActions} onOpenChange={setIsMoreMenuOpen} />
                    </li>
                )}
            </ul>
        </div>
    );
};
